/* eslint-disable @typescript-eslint/camelcase */
import { gracefulFetch } from './gracefulFetch';
import { postEvent } from './postEvent';
import { routes } from '../constants/constants';

interface Props {
  deliveryID: UUID;
}

export interface DeliveryPreviewResponse {
  branding_id: string;
  sender_name_override: string;
  poi_given_name: string;
  poi_last_name_short: string;
  deliveryID?: string;
}

export const getDeliveryPreview = async ({
  deliveryID
}: Props): Promise<DeliveryPreviewResponse | undefined> => {
  let response: Response | null = null;

  if (!deliveryID) {
    if (window.location.pathname !== routes.HOME) {
      window.location.pathname = routes.HOME;
    }
    return;
  }

  try {
    response = await gracefulFetch({
      fetch: async () =>
        fetch(
          `${process.env.REACT_APP_BOX_API}/delivery/${deliveryID}/preview`,
          {
            cache: 'no-store',
            method: 'GET',
            headers: {
              Accept: 'application/json'
            }
          }
        ),
      tries: 1
    });
  } catch (error) {
    postEvent({
      uuid: deliveryID,
      event: 'WEB.JUMP.ERROR',
      details: {
        info: 'getDeliveryPreview',
        error: (error as any)?.message || error,
        stack: (error as any)?.stack
      }
    });
  }

  if (response && response.ok) {
    const json = await response.json();
    return { ...json, deliveryID };
  } else {
    postEvent({
      uuid: deliveryID,
      event: 'WEB.JUMP.ERROR',
      details: {
        info: 'getDeliveryPreview',
        status: response && response.status
      }
    });
  }
};
